module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms03-d8dc7b9d364edf1b38eb010046fcae61.jpg";